import React from 'react';

interface BadgeProps {
    variant?: keyof typeof BadgeVariant;
    backgroundColor?: string;
    textColor?: string;
    borderColor?: string;
    className?: string;
    children?: React.ReactNode;
}

export enum BadgeVariant {
    info = 'info',
    success = 'success',
    warning = 'warning',
    danger = 'danger',
    citation = 'citation',
}

export function Badge({
    variant = 'info',
    backgroundColor,
    textColor,
    borderColor,
    children,
    className = '',
}: BadgeProps) {
    const baseStyles = 'block inline-flex items-center p-4 font-medium rounded-md text-xs';

    const variants = {
        info: 'bg-info text-infoText border border-info bg-opacity-10 border-opacity-30',
        success: 'bg-success text-successText border border-successText bg-opacity-10 border-opacity-30',
        warning: 'bg-warning text-warningText border border-warning bg-opacity-10 border-opacity-30',
        danger: 'bg-danger text-dangerText border border-danger bg-opacity-10 border-opacity-30',
        citation:
            'bg-gray-400 text-gray-400 border border-gray-400 bg-opacity-20 border-opacity-0 !py-0 !px-1 !text-2xs',
    };

    const variantStyles = variant ? variants[variant] : '';

    const customStyles = {
        backgroundColor: backgroundColor,
        color: textColor,
        borderColor: borderColor,
    };

    return (
        <span className={`${baseStyles} ${variantStyles} ${className}`} style={customStyles}>
            {children}
        </span>
    );
}
